<style lang="scss">
  body a {
    transition: color, background-color 0.5s, 0.5s;
}
.clearfix{
    clear: both;
}
.clearfix:after, .clearfix:before, .container:after, .container:before{
    display: table;
    content: " ";
    clear: both;
}
.header{
  height: 80px;
    line-height: 80px;
    padding-top: 0;
    background-color: rgba(44, 45, 58, 0.9);
    border: none;
}
  .container{
    width:100%;
    max-width:100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    position: relative;
}
.mobile{
  display: none;
}
.hide-mobile{
  height: 100%;
}
.hide-mobile .logo{
  float: left;
  height: 100%;
}
.hide-mobile .nav{
  margin: 0;
  float: left;
  padding-top: 10px;
  padding-left: 20px;
  height: 100%;
}
.hide-mobile .nav li{
  width: 90px;
  display: block;
  float: left;
}
.hide-mobile .nav li a{
  padding: 0 15px;
  line-height: 70px;
  color: #fff;
  font-size: 14px;
  display: block;
}
.hide-mobile .nav .has-child{
  position: relative;
  margin-right: 30px;
}
.hide-mobile .nav .has-child ul{
  background: white;
  position: absolute;
  top: 60px;
  left: 0;
  transition: background 0.5s;
  max-height: 0px;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
  padding: 0;
  line-height: 50px;
}
.hide-mobile .nav .has-child:hover ul{
  max-height: 300px;
  overflow: visible !important;
  z-index: 999;
}
.hide-mobile .nav li.has-child ul li {
    white-space: nowrap;
    width: 100%;
}
.hide-mobile .nav li.has-child ul li:hover {
    background: #5e5f68;
}
.hide-mobile .nav li.has-child ul li:hover a{
    color: #fff;
}
.hide-mobile .nav li.has-child ul li a {
    padding: 15px;
    display: inline-block;
    width: 100%;
    height: 100%;
    color: #737278;
    line-height: 1.5;
}
.hide-mobile .nav .has-child .blog-list {
    position: absolute;
    width: 500px !important;
    top: 0;
    display: flex;
    box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.15);
    z-index: 3;
    left: 0;
    align-items: stretch;
    background-color: white;
    color: #4a4a4a;
}
.hide-mobile .has-child .blog-list .blog-list-left {
    background-color: whitesmoke;
    width: 150px;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item{
  width: 150px;
  cursor: pointer;
  padding: 20px 16px 10px;
  background-color: whitesmoke;
  display: grid;
  margin: 0;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item.active {
    position: relative;
    background-color: #0a9faf;
    color: #fff !important;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item.active span{
    color: #fff !important;
}

.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item p {
    font-weight: bold;
    line-height: 1 !important;
    margin: 0;
    padding: 0;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item span {
  color: #8a8a8a;
  font-size: 14px;
  display: inline;
  white-space: normal !important;
  line-height: 1.5;
  margin: 0;
  padding: 0;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item i {
  left: 138px;
  display: none;
  top:50%;
}
.hide-mobile .has-child .blog-list .blog-list-left .blog-list-left-item.active i {
  display: table;
}
.hide-mobile .nav .has-child i{
  position: absolute;
  right: 0;
  line-height: 70px;
  top: 50%;
  margin-top: -35px;
}
.hide-mobile .has-child .blog-list .blog-list-right{
  flex: 1 1;
    background-color: white;
    padding-bottom: 20px;
}
.hide-mobile .has-child .blog-list .blog-list-right .blog-list-right-row-label{
  float: left;
    padding: 23px 15px 0;
    line-height: 16px !important;
    width: 90px;
    font-weight: bold;
    white-space: normal;
}
.hide-mobile .has-child .blog-list .blog-list-right .blog-list-right-row-label a{
  display: inline-block;
    width: 100%;
    height: 100%;
    color: #737278;
    padding: 0 !important;
    line-height: unset !important;
}
.hide-mobile .has-child .blog-list .blog-list-right .blog-list-right-row-a{
  padding-top: 20px !important;
    width: calc(100% - 90px);
    line-height: 1.5 !important;
    float: left;
}
.hide-mobile .has-child .blog-list .blog-list-right .blog-list-right-row-a a{
  height: 100%;
  line-height: 1.5;
    color: #737278;
    padding: unset !important;
    display: inline-block !important;
    width: unset !important;
    margin-right: 6px;
    margin-left: 0;
    float: left;
}
.hide-mobile .has-child .blog-list .blog-list-right .blog-list-right-row-a a:hover{
  color: #0a9faf !important;
}
  .search {
    float: right;
    line-height: 80px;
    position: absolute;
    top: 0;
    right: 0;
  }
.nav-cover {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0,0,0,0.5);
    z-index: 10000;
}
.nav-cover .left {
    outline: none;
    width: 40%;
    min-width: 150px;
    height: 100%;
    overflow: auto;
    background-color: #2b2b2b;
    padding: 30px 10px 0;
    font-size: 14px;
}
.nav-cover .left >li {
    border-bottom: 1px solid rgba(255, 255, 255,0.1);
}
.nav-cover .left li a, .nav-cover .left li {
    color: #fff;
    display: block;
    line-height: 34px;
    padding-left: 10px;
}
.rightButton.active + .mobile_nav_right {
    right: 0px;
    transition: all 0.5s;
}
.mobile_nav_right {
    padding: 30px 10px 0;
    position: fixed;
    width: calc(100vw - 40%);
    z-index: -1;
    height: 100vh;
    overflow: auto;
    top: 0;
    right: calc(100vw - 40%);
    background: #D7D7D7;
}
.rightButton.active {
    background-color: #099FAF;
}
.rightButton.active + .mobile_nav_right {
    right: 0px;
    transition: all 0.5s;
}
.mobile_nav_right {
    padding: 30px 10px 0;
    position: fixed;
    width: calc(100vw - 40%);
    z-index: -1;
    height: 100vh;
    overflow: auto;
    top: 0;
    right: calc(100vw - 40%);
    background: #D7D7D7;
}

.mobile_nav_right .close{
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 2;
    cursor: pointer;
    color: #363532;
}
.mobile_nav_right a {
    color: #000 !important;
    display: block;
    border-bottom: 1px solid #aaa;
}
.sub_area_item ul a {
    color: #666 !important;
}
.sub_area_item a{
    position: relative;
}
.sub_area_item i{
  right: 5px;
    position: absolute;
    transform: rotate(0deg);
    transition: all 0.3s;
    top: 10px;
}
.rotate_item_bro{
  transition: all 0.3s;
}
/* lg */
@media (min-width:1200px){
  .container{
    max-width:1360px;
  }
}
/* md */
@media (min-width:992px){
  .container{
    width:95%;
  }
}
/* sm */
@media (min-width: 768px) {
  
}
/* xs */
@media (max-width: 767px) {
  .header{
    height: 50px;
  }
  .mobile{
    display: block;
    height: 100%;
  }
  .mobile .menu {
    float: left;
    line-height: 50px;
    margin-right: 15%;
  }
  .mobile .mobile-logo{
    width: 50%;
    float: left;
    height: 50px;
    display: block;
    text-align: center;
  }
  .mobile .mobile-logo img{
    height: 50px;
  }

  .hide-mobile{
    display: none;
  }
  .search {
    float: right;
    line-height: 50px;
  }
}
</style>
<template>
<div>
    <Row type="flex" justify="center" class="header">
        <div class="container">
          <div class="mobile">
            <a href="javascript:void(0)" @click="mobileMenu = true" class="menu">
              <Icon type="md-menu" color="#fff" size="30" />
            </a>
            <a href="https://www.travelliker.com.hk/blog" class="mobile-logo">
              <img src="https://www.travelliker.com.hk/img/blogs/logo02.png">
            </a>
          </div>
          <div class="hide-mobile">
            <a href="https://www.travelliker.com.hk/blog" class="logo">
              <img src="https://www.travelliker.com.hk/img/blogs/logo02.png">
            </a>
            <ul class="nav">
              <li><a href="https://www.travelliker.com.hk">機票</a></li>
              <li><a href="https://www.travelliker.com.hk/attraction/airfare">航班優惠</a></li>
              <li><a href="https://www.travelliker.com.hk/hotel">酒店</a></li>
              <li class="has-child">
                <a href="https://www.travelliker.com.hk/blog">旅遊資訊
                  <Icon type="ios-arrow-down" color="#fff" /></a>
                <ul class="blogNavTab">
                  <li class="blog-list">
                    <div class="blog-list-left">
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 0}" @mouseover="showItem = 0">
                        <p>亞洲</p>
                        <span>港澳地區 日本 泰國</span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 1}" @mouseover="showItem = 1">
                        <p>歐洲</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 2}" @mouseover="showItem = 2">
                        <p>美洲</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 3}" @mouseover="showItem = 3">
                        <p>澳洲</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 4}" @mouseover="showItem = 4">
                        <p>非洲</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 5}" @mouseover="showItem = 5">
                        <p>其他</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                      <div class="blog-list-left-item clearfix" v-bind:class="{active:showItem == 6}" @mouseover="showItem = 6">
                        <p>航班優惠</p>
                        <span></span>
                        <Icon type="md-arrow-dropright" size="30" color="#0a9faf" />
                      </div>
                    </div>
                    <div class="blog-list-right">
                      <div class="blog-list-right-item clearfix" v-show="showItem == 0">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/taiwan">台灣</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/taipei">台北</a>
                            <a href="/attraction/tainan">台南</a>
                            <a href="/attraction/taichung">台中</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/japan">日本</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/tokyo">東京</a>
                            <a href="/attraction/osaka">大阪</a>
                            <a href="/attraction/kyoto">京都</a>
                            <a href="/attraction/kobe">神戶</a>
                            <a href="/attraction/hokkaido">北海道</a>
                            <a href="/attraction/sapporo">札幌</a>
                            <a href="/attraction/otaru">小樽</a>
                            <a href="/attraction/fukuoka">福岡</a>
                            <a href="/attraction/okinawa">沖繩</a>
                            <a href="/attraction/noboribetsu">登別</a>
                            <a href="/attraction/aso">阿蘇</a>
                            <a href="/attraction/okayama">岡山</a>
                            <a href="/attraction/nara">奈良</a>
                            <a href="/attraction/sounkyo">層雲峽</a>
                            <a href="/attraction/nagoya">名古屋</a>
                            <a href="/attraction/kagoshima">鹿兒島</a>
                            <a href="/attraction/shinjuku">新宿</a>
                            <a href="/attraction/miyazaki">宮崎</a>
                            <a href="/attraction/kanazawa">金澤</a>
                            <a href="/attraction/furano">富良野</a>
                            <a href="/attraction/shikoku">四國</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/korea">韓國</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/seoul">首爾</a>
                            <a href="/attraction/busan">釜山</a>
                            <a href="/attraction/jeju">濟州</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/thailand">泰國</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/bangkok">曼谷</a>
                            <a href="/attraction/pattaya">芭堤雅</a>
                            <a href="/attraction/huahin">華欣</a>
                            <a href="/attraction/chiangmai">清邁</a>
                            <a href="/attraction/chiangrai">清萊</a>
                            <a href="/attraction/ayutthaya">大城府</a>
                            <a href="/attraction/sukhothai">素可泰</a>
                            <a href="/attraction/rayong">羅勇</a>
                            <a href="/attraction/thailand_other">其他</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/singapore">新加坡</a></div>
                          <div class="blog-list-right-row-a">
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/malaysia">馬來西亞</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/johorbahru">新山</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/Vietnam">越南</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/danang">峴港</a>
                          </div>
                        </div>
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/china">中國</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="/attraction/shenzhen">深圳</a>
                            <a href="/attraction/hongkong">香港</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 1">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/europe">歐洲</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/France">法國</a>
                            <a href="https://www.travelliker.com.hk/attraction/Italy">意大利</a>
                            <a href="https://www.travelliker.com.hk/attraction/Spain">西班牙</a>
                            <a href="https://www.travelliker.com.hk/attraction/northerneurope">北歐</a>
                            <a href="https://www.travelliker.com.hk/attraction/russia">俄羅斯</a>
                            <a href="https://www.travelliker.com.hk/attraction/Iceland">冰島</a>
                            <a href="https://www.travelliker.com.hk/attraction/Norway">挪威</a>
                            <a href="https://www.travelliker.com.hk/attraction/Switzerland">瑞士</a>
                            <a href="https://www.travelliker.com.hk/attraction/Netherlands">荷蘭</a>
                            <a href="https://www.travelliker.com.hk/attraction/Belgium">比利時</a>
                            <a href="https://www.travelliker.com.hk/attraction/Croatia">克羅地亞</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 2">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/Americas">美洲</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/america">美國</a>
                            <a href="https://www.travelliker.com.hk/attraction/canada">加拿大</a>
                            <a href="https://www.travelliker.com.hk/attraction/Cuba">古巴</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 3">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/Australia">澳洲</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/Sydney">悉尼</a>
                            <a href="https://www.travelliker.com.hk/attraction/Brisbane">布里斯本</a>
                            <a href="https://www.travelliker.com.hk/attraction/Melbourne">墨爾本</a>
                            <a href="https://www.travelliker.com.hk/attraction/GoldCoast">黃金海岸</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 4">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/Africa">非洲</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/Egypt">埃及</a>
                            <a href="https://www.travelliker.com.hk/attraction/SouthAfrica">南非</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 5">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/other">其他</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/Myanmar">緬甸</a>
                            <a href="https://www.travelliker.com.hk/attraction/Nepal">尼泊爾</a>
                            <a href="https://www.travelliker.com.hk/attraction/NewZealand">紐西蘭</a>
                            <a href="https://www.travelliker.com.hk/attraction/dubai">杜拜</a>
                            <a href="https://www.travelliker.com.hk/attraction/turkey">土耳其</a>
                            <a href="https://www.travelliker.com.hk/attraction/cambodia">菲律賓</a>
                          </div>
                        </div>
                      </div>
                      <div class="blog-list-right-item clearfix" v-show="showItem == 6">
                        <div class="blog-list-right-row clearfix">
                          <div class="blog-list-right-row-label"><a href="/attraction/airfare">航班優惠</a></div>
                          <div class="blog-list-right-row-a">
                            <a href="https://www.travelliker.com.hk/attraction/2018">2018年</a>
                            <a href="https://www.travelliker.com.hk/attraction/2017">2017年</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li><a href="https://www.travelliker.com.hk/daytour">當地游</a></li>
              <li class="has-child">
                <a href="javascript:void(0)">租借服務
                  <Icon type="ios-arrow-down" color="#fff" /></a>
                <ul>
                  <li class=""><a href="https://www.travelliker.com.hk/rimowa" target="_blank">租借行李箱</a></li>
                  <li class=""><a href="https://www.travelliker.com.hk/gopro" target="_blank">租借運動相機</a></li>
                  <li class=""><a href="https://www.travelliker.com.hk/camera360" target="_blank">租借360全景攝錄機</a></li>
                  <li class=""><a href="https://www.travelliker.com.hk/pocketwifi" target="_blank">租借WIFI蛋</a></li>
                </ul>
              </li>
              <li><a href="https://www.travelliker.com.hk/insurance">旅遊保險</a></li>
              <li class="has-child">
                <a href="javascript:void(0)">Blogger
                  <Icon type="ios-arrow-down" color="#fff" /></a>
                <ul>
                  <li class=""><a href="https://www.travelliker.com.hk/attraction?author=travelliker" target="_blank">Blogger專欄</a></li>
                  <li class=""><a href="#/login" target="_blank">登入/註冊</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <a href="https://www.travelliker.com.hk/blog" target="_blank" class="search">
            <Icon type="md-search" color="#fff" size="30" />
          </a>
        </div>
      </Row>
    </Row>
    <div class="nav-cover" v-show="mobileMenu" @click="mobileMenu = false">
      <ul class="left" tabindex="1" @click.stop="mobileMenu = true">
        <li class=""><a href="https://www.travelliker.com.hk/">機票</a></li>
        <li class=""><a href="https://www.travelliker.com.hk/attraction/airfare" target="_blank">航班優惠</a></li>
        <li>
          <a href="javascript:void(0)" @click="showmenu1 == true?showmenu1 = false:showmenu1 = true">旅遊資訊
            <Icon type="ios-arrow-forward" size="14px" color="#fff" /></a>
          <ul id="collapse_blog" class="collapse" v-show="showmenu1 == true">
            <li>
              <a target="#area1" role="button" class="rightButton" v-bind:class="{active:showCity == 0}" @click="showCity == 0?showCity=null:showCity=0">亞洲</a>
              <div id="area1" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">台灣
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/taiwan" target="_blank">台灣</a>
                    <a href="https://www.travelliker.com.hk/attraction/taipei" target="_blank">台北</a>
                    <a href="https://www.travelliker.com.hk/attraction/tainan" target="_blank">台南</a>
                    <a href="https://www.travelliker.com.hk/attraction/taichung" target="_blank">台中</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">日本
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea12" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/japan" target="_blank">日本</a>
                    <a href="https://www.travelliker.com.hk/attraction/tokyo" target="_blank">東京</a>
                    <a href="https://www.travelliker.com.hk/attraction/osaka" target="_blank">大阪</a>
                    <a href="https://www.travelliker.com.hk/attraction/kyoto" target="_blank">京都</a>
                    <a href="https://www.travelliker.com.hk/attraction/kobe" target="_blank">神戶</a>
                    <a href="https://www.travelliker.com.hk/attraction/hokkaido" target="_blank">北海道</a>
                    <a href="https://www.travelliker.com.hk/attraction/sapporo" target="_blank">札幌</a>
                    <a href="https://www.travelliker.com.hk/attraction/otaru" target="_blank">小樽</a>
                    <a href="https://www.travelliker.com.hk/attraction/fukuoka" target="_blank">福岡</a>
                    <a href="https://www.travelliker.com.hk/attraction/okinawa" target="_blank">沖繩</a>
                    <a href="https://www.travelliker.com.hk/attraction/noboribetsu" target="_blank">登別</a>
                    <a href="https://www.travelliker.com.hk/attraction/aso" target="_blank">阿蘇</a>
                    <a href="https://www.travelliker.com.hk/attraction/okayama" target="_blank">岡山</a>
                    <a href="https://www.travelliker.com.hk/attraction/nara" target="_blank">奈良</a>
                    <a href="https://www.travelliker.com.hk/attraction/sounkyo" target="_blank">層雲峽</a>
                    <a href="https://www.travelliker.com.hk/attraction/nagoya" target="_blank">名古屋</a>
                    <a href="https://www.travelliker.com.hk/attraction/kagoshima" target="_blank">鹿兒島</a>
                    <a href="https://www.travelliker.com.hk/attraction/shinjuku" target="_blank">新宿</a>
                    <a href="https://www.travelliker.com.hk/attraction/miyazaki" target="_blank">宮崎</a>
                    <a href="https://www.travelliker.com.hk/attraction/kanazawa" target="_blank">金澤</a>
                    <a href="https://www.travelliker.com.hk/attraction/furano" target="_blank">富良野</a>
                    <a href="https://www.travelliker.com.hk/attraction/shikoku" target="_blank">四國</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">韓國
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea13" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/korea" target="_blank">韓國</a>
                    <a href="https://www.travelliker.com.hk/attraction/seoul" target="_blank">首爾</a>
                    <a href="https://www.travelliker.com.hk/attraction/busan" target="_blank">釜山</a>
                    <a href="https://www.travelliker.com.hk/attraction/jeju" target="_blank">濟州</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">泰國
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea14" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/thailand" target="_blank">泰國</a>
                    <a href="https://www.travelliker.com.hk/attraction/bangkok" target="_blank">曼谷</a>
                    <a href="https://www.travelliker.com.hk/attraction/pattaya" target="_blank">芭堤雅</a>
                    <a href="https://www.travelliker.com.hk/attraction/huahin" target="_blank">華欣</a>
                    <a href="https://www.travelliker.com.hk/attraction/chiangmai" target="_blank">清邁</a>
                    <a href="https://www.travelliker.com.hk/attraction/chiangrai" target="_blank">清萊</a>
                    <a href="https://www.travelliker.com.hk/attraction/ayutthaya" target="_blank">大城府</a>
                    <a href="https://www.travelliker.com.hk/attraction/sukhothai" target="_blank">素可泰</a>
                    <a href="https://www.travelliker.com.hk/attraction/rayong" target="_blank">羅勇</a>
                    <a href="https://www.travelliker.com.hk/attraction/thailand_other" target="_blank">其他</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">新加坡
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea15" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/singapore" target="_blank">新加坡</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">馬來西亞
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea16" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/malaysia" target="_blank">馬來西亞</a>
                    <a href="https://www.travelliker.com.hk/attraction/johorbahru" target="_blank">新山</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">越南
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea17" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/Vietnam" target="_blank">越南</a>
                    <a href="https://www.travelliker.com.hk/attraction/danang" target="_blank">峴港</a>
                  </ul>
                </div>
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">中國
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea18" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/china" target="_blank">中國</a>
                    <a href="https://www.travelliker.com.hk/attraction/shenzhen" target="_blank">深圳</a>
                    <a href="https://www.travelliker.com.hk/attraction/hongkong" target="_blank">香港</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area2" role="button" class="rightButton" v-bind:class="{active:showCity == 1}" @click="showCity == 1?showCity=null:showCity=1">歐洲</a>
              <div id="area2" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">歐洲
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea21" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/europe" target="_blank">歐洲</a>
                    <a href="https://www.travelliker.com.hk/attraction/France" target="_blank">法國</a>
                    <a href="https://www.travelliker.com.hk/attraction/Italy" target="_blank">意大利</a>
                    <a href="https://www.travelliker.com.hk/attraction/Spain" target="_blank">西班牙</a>
                    <a href="https://www.travelliker.com.hk/attraction/northerneurope" target="_blank">北歐</a>
                    <a href="https://www.travelliker.com.hk/attraction/russia" target="_blank">俄羅斯</a>
                    <a href="https://www.travelliker.com.hk/attraction/Iceland" target="_blank">冰島</a>
                    <a href="https://www.travelliker.com.hk/attraction/Norway" target="_blank">挪威</a>
                    <a href="https://www.travelliker.com.hk/attraction/Switzerland" target="_blank">瑞士</a>
                    <a href="https://www.travelliker.com.hk/attraction/Netherlands" target="_blank">荷蘭</a>
                    <a href="https://www.travelliker.com.hk/attraction/Belgium" target="_blank">比利時</a>
                    <a href="https://www.travelliker.com.hk/attraction/Croatia" target="_blank">克羅地亞</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area3" role="button" class="rightButton" v-bind:class="{active:showCity == 2}" @click="showCity == 2?showCity=null:showCity=2">美洲</a>
              <div id="area3" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">美洲
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea31" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/Americas" target="_blank">美洲</a>
                    <a href="https://www.travelliker.com.hk/attraction/america" target="_blank">美國</a>
                    <a href="https://www.travelliker.com.hk/attraction/canada" target="_blank">加拿大</a>
                    <a href="https://www.travelliker.com.hk/attraction/Cuba" target="_blank">古巴</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area4" role="button" class="rightButton" v-bind:class="{active:showCity == 3}" @click="showCity == 3?showCity=null:showCity=3">澳洲</a>
              <div id="area4" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">澳洲
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea41" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/Australia" target="_blank">澳洲</a>
                    <a href="https://www.travelliker.com.hk/attraction/Sydney" target="_blank">悉尼</a>
                    <a href="https://www.travelliker.com.hk/attraction/Brisbane" target="_blank">布里斯本</a>
                    <a href="https://www.travelliker.com.hk/attraction/Melbourne" target="_blank">墨爾本</a>
                    <a href="https://www.travelliker.com.hk/attraction/GoldCoast" target="_blank">黃金海岸</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area5" role="button" class="rightButton" v-bind:class="{active:showCity == 4}" @click="showCity == 4?showCity=null:showCity=4">非洲</a>
              <div id="area5" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">非洲
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea51" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/Africa" target="_blank">非洲</a>
                    <a href="https://www.travelliker.com.hk/attraction/Egypt" target="_blank">埃及</a>
                    <a href="https://www.travelliker.com.hk/attraction/SouthAfrica" target="_blank">南非</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area6" role="button" class="rightButton" v-bind:class="{active:showCity == 5}" @click="showCity == 5?showCity=null:showCity=5">其他</a>
              <div id="area6" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">其他
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea61" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/other" target="_blank">其他</a>
                    <a href="https://www.travelliker.com.hk/attraction/Myanmar" target="_blank">緬甸</a>
                    <a href="https://www.travelliker.com.hk/attraction/Nepal" target="_blank">尼泊爾</a>
                    <a href="https://www.travelliker.com.hk/attraction/NewZealand" target="_blank">紐西蘭</a>
                    <a href="https://www.travelliker.com.hk/attraction/dubai" target="_blank">杜拜</a>
                    <a href="https://www.travelliker.com.hk/attraction/turkey" target="_blank">土耳其</a>
                    <a href="https://www.travelliker.com.hk/attraction/cambodia" target="_blank">菲律賓</a>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <a target="#area7" role="button" class="rightButton" v-bind:class="{active:showCity == 6}" @click="showCity == 6?showCity=null:showCity=6">航班優惠</a>
              <div id="area7" class="mobile_nav_right">
                <Icon type="md-close" size="15" color="#000" class="close" @click="showCity = null" />
                <div class="sub_area_item">
                  <a href="javascript:void(0)" @click="clickMenu($event)">航班優惠
                    <Icon type="ios-arrow-down" size="14" /></a>
                  <ul id="subarea71" class="collapse rotate_item_bro" style="display:none">
                    <a href="https://www.travelliker.com.hk/attraction/airfare" target="_blank">航班優惠</a>
                    <a href="https://www.travelliker.com.hk/attraction/2018" target="_blank">2018年</a>
                    <a href="https://www.travelliker.com.hk/attraction/2017" target="_blank">2017年</a>
                  </ul>
                </div>
              </div>
            </li>

          </ul>
        </li>
        <li class=""><a href="/daytour" target="_blank">當地游</a></li>
        <li>
          <a href="javascript:void(0)" role="button" data-toggle="collapse" @click="showmenu2 == true?showmenu2 = false:showmenu2 = true">租借服務
            <Icon type="ios-arrow-forward" size="14px" color="#fff" /></a>
          <ul id="collapse_rant" class="collapse" v-show="showmenu2 == true">
            <li class=""><a href="https://www.travelliker.com.hk/rimowa" target="_blank">租借行李箱</a></li>
            <li class=""><a href="https://www.travelliker.com.hk/gopro" target="_blank">租借運動相機</a></li>
            <li class=""><a href="https://www.travelliker.com.hk/camera360" target="_blank">租借360全景攝錄機</a></li>
            <li class=""><a href="https://www.travelliker.com.hk/pocketwifi" target="_blank">租借WIFI蛋</a></li>
          </ul>
        </li>
        <li class=""><a href="https://www.travelliker.com.hk/insurance" target="_blank">旅遊保險</a></li>
        <li class=""><a href="https://www.travelliker.com.hk/blog">旅遊資訊</a></li>
        <li>
          <a href="javascript:void(0)" role="button" data-toggle="collapse" @click="showmenu3 == true?showmenu3 = false:showmenu3 = true">Blogger
            <Icon type="ios-arrow-forward" size="14px" color="#fff" /></a>
          <ul id="collapse_rant" class="collapse" v-show="showmenu3 == true">
            <li class=""><a href="https://www.travelliker.com.hk/attraction?author=travelliker" target="_blank">Blogger專欄</a></li>
            <li class=""><a href="#/login" target="_blank">登入/註冊</a></li>
          </ul>
        </li>
      </ul>
    </div>
</div>
</template>
<script>
  export default {
    data() {
      return {
        showmenu1: false,
        showCity: null,
        showmenu2: false,
        showmenu3: false,
        showItem: 0,
        mobileMenu: false,
      };
    },
    created() {

    },
    methods: {
      clickMenu(e) {
        if (e.currentTarget.nextElementSibling.style.display == 'none') {
          e.currentTarget.nextElementSibling.style.display = 'block';
          e.currentTarget.firstElementChild.classList.add('ivu-icon-ios-arrow-up');
          e.currentTarget.firstElementChild.classList.remove('ivu-icon-ios-arrow-down');
        } else {
          e.currentTarget.nextElementSibling.style.display = 'none'
          e.currentTarget.firstElementChild.classList.remove('ivu-icon-ios-arrow-up');
          e.currentTarget.firstElementChild.classList.add('ivu-icon-ios-arrow-down');
        }
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/public/Header.vue